<script>
    import LayoutGrid, {Cell as LayoutCell} from "@smui/layout-grid";
    import DataTable, {Body, Cell, Row} from "@smui/data-table";
    import {Subtitle, Title} from "@smui/paper";

    import Currency from "../component/Currency.svelte";
    import Percent from "../component/Percent.svelte";
    import NumberElt from "../component/Number.svelte";

    import {workingDays, globalState} from '../store/store.js';


    export let result = undefined;
    export let span = 4;
    export let cssClass = "no-web";

    let firstName = null;
    let lastName = null;
    let monthYearStore = null;
    let monthYear = null;
    let currentDate = new Date();
    let vacation = false;

    for (const [key, value] of Object.entries($globalState)) {
        if ('o' === key) {
            firstName = value;
        } else if ('p' === key) {
            lastName = value;
        } else if ('n' === key) {
            monthYearStore = value;
        } else if ('s' === key) {
            vacation = value
        }
    }

    if (monthYearStore) {
        let [year, month] = monthYearStore.split("-");
        let myDate = new Date(year, month - 1, 1);
        monthYear = new Intl.DateTimeFormat("fr-FR", {
            month: "long",
            year: "numeric"
        }).format(myDate);
    } else {
        monthYear = new Intl.DateTimeFormat('fr-FR', {month: 'long', year: 'numeric'}).format(currentDate);
    }
    monthYear = monthYear.charAt(0).toUpperCase() + monthYear.slice(1);

    function getValue(result, key, period = "monthly") {
        let periodFactor = period === "yearly" && key !== "dailyRate" ? 12 : 1;
        return result[key] * periodFactor;
    }

    $: isDifferent = Number($workingDays) !== Number(result.daysPerMonth);

</script>

<LayoutCell span={span} class="{cssClass}">
    <Title style="font-weight: bold">BULLETIN DE SALAIRE</Title>
    <Subtitle>Période : {monthYear}
        {#if firstName || lastName}
            pour <strong>{firstName} {lastName}</strong>
        {/if}
    </Subtitle>

    <DataTable table$aria-label="salary-head-right-one" style="width: 100%;">
        <Body>
        <Row style="height: 20px;">
            <Cell>Chiffre d'affaires HT</Cell>
            <Cell numeric>
                <Currency number={getValue(result, "invoiceAmount")}/>
            </Cell>
            <Cell></Cell>
        </Row>
        <Row style="height: 20px;">
            <Cell>Commission de portage</Cell>
            <Cell numeric style="text-align: right">
                <Percent number={getValue(result, "portageFeesRate")}/>
            </Cell>
            <Cell numeric style="text-align: right">
                <Currency number={getValue(result, "portageFees")}/>
            </Cell>
        </Row>
        <Row style="height: 20px;">
            <Cell>Mutuelle</Cell>
            <Cell numeric style="text-align: right">
                {#if result.metadata.input.hasMutuelle}
                    Oui
                {:else}
                    Non
                {/if}
            </Cell>
            <Cell></Cell>
        </Row>
        <Row style="height: 20px;">
            <Cell>
                {#if !vacation}
                    Congés provisionnés
                {:else}
                    Congés payés
                {/if}
            </Cell>
            <Cell numeric style="text-align: right">
                Oui
            </Cell>
            <Cell numeric style="text-align: right">
                <NumberElt number={$workingDays}/>
                jours
            </Cell>
        </Row>
        <Row style="height: 20px;">
            <Cell>Frais optimisables</Cell>
            <Cell numeric style="text-align: right">
                <Currency number={result.travellingExpenses}/>
            </Cell>
            <Cell></Cell>
        </Row>
        <Row style="height: 20px;">
            <Cell>Provisions</Cell>
            <Cell numeric style="text-align: right">
                <Percent number={result.otherProvisionsRate + result.conventionalRuptureRate}/>
            </Cell>
            <Cell numeric style="text-align: right">
                <Currency number={result.rawData.variables.provisions.value}/>
            </Cell>
        </Row>
        <Row style="height: 20px;">
            <Cell>Total Brut de Base</Cell>
            <Cell numeric>
                <Currency number={result.totalBaseGross}/>
            </Cell>
            <Cell></Cell>
        </Row>
        </Body>
    </DataTable>
    <!--<br><br>
    <DataTable table$aria-label="salary-head-right-two" style="width: 100%;">
        <Body>
        <Row style="height: 25px;">
            <Cell>Plafond sécurité sociale</Cell>
            <Cell numeric><Currency number={result.rawData.constants.monthlySocialSecurityCeiling.amount} /></Cell>
        </Row>
        <Row style="height: 25px;">
            <Cell>Total Brut de Base</Cell>
            <Cell numeric><Currency number={result.totalBaseGross} /></Cell>
        </Row>
        </Body>
    </DataTable>-->
</LayoutCell>